<template>
  <div class="review">
    <div class="query-item">
      <div class="search-l">
        <div v-if="!store.roles.includes('carEnterprise')" style="margin-right: 30px">
          测试主体
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
        </div>
        <div>
          测试牌照
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
        </div>
        <div class="ml30" v-if="!store.roles.includes('carEnterprise')">
          日期
          <a-range-picker class="ml24" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" @change="timeChange"
            v-model:value="time" />
        </div>
        <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <div v-if="store.roles.includes('carEnterprise')">
        <a-button class="ml24" @click="add" type="primary">上传事故报告</a-button>
      </div>
    </div>
    <a-table :columns="store.roles.includes('carEnterprise') ? columns : columns2" :row-key="(record) => record.id"
      :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
      v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'responsibilityType'">
          {{
            record.responsibilityType === 0
              ? "无责任"
              : record.responsibilityType === 1
                ? "次要责任"
                : record.responsibilityType === 2
                  ? "同等责任"
                  : record.responsibilityType === 3
                    ? "主要责任"
                    : record.responsibilityType === 4
                      ? "全部责任"
                      : ""
          }}
        </template>
        <template v-if="column.key === 'driver'">
          <span v-for="(item, index) in record.testPersons" :key="index">
            {{
              item.personType
                ? item.personType.indexOf("driver") != "-1"
                  ? item.name + " "
                  : ""
                : ""
            }}
          </span>
        </template>
        <template v-if="column.key === 'securityOfficer'">
          <span v-for="(item, index) in record.testPersons" :key="index">
            {{
              item.personType
                ? item.personType.indexOf("security") != "-1"
                  ? item.name + " "
                  : ""
                : ""
            }}
          </span>
        </template>

        <template v-if="column.key === 'action'">
          <span>
            <a class="mr10" @click="detail(record)">详情</a>
            <!-- <a-popconfirm
              title="确定删除?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="del(record)"
            >
              <a class="ml10">删除</a>
            </a-popconfirm> -->
          </span>
        </template>
      </template>
    </a-table>

    <detailModal :modalTitle="title" :modalWidth="'702px'" :isDetailStatus="title == '上传报告' ? true : false"
      ref="modalRef" @saveEvent="saveEvent" @cancelEvent="cancelEvent">
      <div class="detail add" v-if="title == '上传报告'">
        <div class="cars">
          <div class="item">
            <div class="tit">测试牌照</div>
            <a-select v-model:value="form.carId" style="width: 100%" placeholder="请选择" @change="testCarNumChange">
              <a-select-option v-for="item in testCarNumList" :key="item.id" :value="item.id">{{ item.testCarNum
                }}</a-select-option>
            </a-select>
          </div>
          <div class="item">
            <div class="tit">发生时间</div>
            <a-date-picker show-time placeholder="选择时间" style="width: 100%" format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.happenTimeStr" />
          </div>
          <div class="item">
            <div class="tit">发生地点</div>
            <a-input v-model:value="form.accidentAddress" placeholder="请输入" />
          </div>
          <div class="item">
            <div class="tit">事故责任类型</div>
            <a-select v-model:value="form.responsibilityType" style="width: 100%" placeholder="请选择" :options="options">
            </a-select>
          </div>
        </div>
        <div class="filelist">
          <div class="file_text">
            智能网联汽车道路测试或示范应用 交通事故报告
          </div>
          <div class="into">事故报告请于事故责任认定后的5个工作日内上传</div>
          <a :href="fileUrl" target="_blank" class="update_btn">
            <a style="color: #636d7b"><i class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>点击下载</a>
          </a>
        </div>
        <div class="mt16">
          <upload :pathName="'car'" ref="uploadRef" accept=".xls,.docx,.doc" @uploadFinished="uploadFinished">
          </upload>
        </div>
      </div>
      <!-- <div class="detail" v-if="title == '报告详情'">
        <div class="cars">
          <div class="item">
            <div class="tit">测试牌照</div>
            <span>甘A39383测</span>
          </div>
          <div class="item">
            <div class="tit">发生时间</div>
            <span>2024年03月20日</span>
          </div>
          <div class="item">
            <div class="tit">发生地点</div>
            <span>发生地点发生地点发生地点</span>
          </div>
          <div class="item">
            <div class="tit">事故责任类型</div>
            <span>全部责任</span>
          </div>
        </div>
        <div class="filelist">
          <div class="item"><FileTextOutlined />事故报告.xls</div>
          <div class="btns">
            <a-button key="submit" type="primary" @click="download"
              >下载</a-button
            >
          </div>
        </div>
      </div> -->
    </detailModal>

    <a-drawer placement="right" :closable="false" :width="'808px'" v-model:open="open"
      :after-visible-change="afterVisibleChange">
      <template v-slot:title>
        <div>
          <img :src="require('@/assets/icons/bg_icon.png')" style="width: 25px; vertical-align: bottom" alt="" />

          <span class="ml10 first_title">报告详情</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>
      <div class="newDetail">
        <div class="cars">
          <div class="item">
            <div class="tit">测试牌照</div>
            <span>{{ detailForm.testCarNum }}</span>
          </div>
          <div class="item">
            <div class="tit">发生时间</div>
            <span>{{ detailForm.happenTimeStr }}</span>
          </div>
          <div class="item">
            <div class="tit">发生地点</div>
            <span>{{ detailForm.accidentAddress }}</span>
          </div>
          <div class="item">
            <div class="tit">事故责任类型</div>
            <span>
              {{
                detailForm.responsibilityType === 0
                  ? "无责任"
                  : detailForm.responsibilityType === 1
                    ? "次要责任"
                    : detailForm.responsibilityType === 2
                      ? "同等责任"
                      : detailForm.responsibilityType === 3
                        ? "主要责任"
                        : detailForm.responsibilityType === 4
                          ? "全部责任"
                          : ""
              }}
            </span>
          </div>
        </div>
        <div class="filelist">
          <div class="item">
            <FileTextOutlined />事故报告.xls
          </div>
          <div class="btns">
            <a class="upload_a" :href="detailForm.reportFileUrl" target="_blank">下载</a>
          </div>
        </div>
      </div>
      <template v-if="title != '报告详情'" #footer> </template>
    </a-drawer>
  </div>
</template>
<script setup name="task">
import { ref, reactive, toRefs, onBeforeMount, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FileTextOutlined } from "@ant-design/icons-vue";
import detailModal from "@/components/modal/index.vue";
import upload from "@/components/uploadProgress/index.vue";
import { message } from "ant-design-vue";
import useUserStore from "@/store/modules/user";
import { getCars } from "@/api/car/car.js";
import {
  selectPageList,
  getTemplateFileUrl,
  insertOne,
  detailData,
} from "@/api/report/accident.js";

const router = useRouter();
const route = useRoute()
const store = useUserStore();

const title = ref("");
const columns = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "测试区域",
    key: "zoneName",
    dataIndex: "zoneName",
  },
  {
    title: "发生时间",
    key: "happenTimeStr",
    dataIndex: "happenTimeStr",
    width: 160,
  },
  {
    title: "发生地点",
    key: "accidentAddress",
    dataIndex: "accidentAddress",
    width: 200,
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "驾驶员",
    key: "driver",
  },
  {
    title: "安全员",
    key: "securityOfficer",
  },
  {
    title: "事故责任类型",
    key: "responsibilityType",
  },
  {
    title: "上传时间",
    key: "uploadTimeStr",
    dataIndex: "uploadTimeStr",
    width: 160,
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 150,
  },
];

const columns2 = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "测试主体",
    key: "deptName",
    dataIndex: "deptName",
  },
  {
    title: "测试区域",
    key: "zoneName",
    dataIndex: "zoneName",
  },
  {
    title: "发生时间",
    key: "happenTimeStr",
    dataIndex: "happenTimeStr",
    width: 160,
  },
  {
    title: "发生地点",
    key: "accidentAddress",
    dataIndex: "accidentAddress",
    width: 200,
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "驾驶员",
    key: "driver",
  },
  {
    title: "安全员",
    key: "securityOfficer",
  },
  {
    title: "事故责任类型",
    key: "responsibilityType",
  },
  {
    title: "上传时间",
    key: "uploadTimeStr",
    dataIndex: "uploadTimeStr",
    width: 160,
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 150,
  },
];

const time = ref([]);

let query = reactive({
  testCarNum: "",
  startDateStr: "",
  endDateStr: "",
  deptName: "",
});

const timeChange = (value) => {
  console.log(value);
  query.startDateStr = value[0];
  query.endDateStr = value[1];
};

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.testCarNum = "";
  query.startDateStr = "";
  query.endDateStr = "";
  query.deptName = "";
  time.value = [];
  pagination.current = 1;
  getData();
};

let dataSource = ref([]);

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query },
  };
  selectPageList(data).then((res) => {
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

const form = ref({
  testCarNum: "",
  happenTimeStr: "",
  accidentAddress: "",
  responsibilityType: 0,
  reportFileUrl: "",
  carId: "",
});

const resetForm = () => {
  form.value = {
    testCarNum: "",
    happenTimeStr: "",
    accidentAddress: "",
    responsibilityType: 0,
    reportFileUrl: "",
    carId: "",
  };
};
const modalRef = ref();
const del = (record) => {
  console.log(record);
};

const uploadRef = ref();
// uploadRef.value.clearFileList()
const uploadFinished = (res) => {
  console.log("上传成功", res);
  form.value.reportFileUrl = res;
};

const options = ref([
  {
    label: `无责任`,
    value: 0,
  },
  {
    label: `次要责任`,
    value: 1,
  },
  {
    label: `同等责任`,
    value: 2,
  },
  {
    label: `主要责任`,
    value: 3,
  },
  {
    label: `全部责任`,
    value: 4,
  },
]);

const testCarNumList = ref([]);
const getCarsData = () => {
  getCars({
    pageIndex: null,
    pageSize: null,
    conditionMap: {
      deptName: "",
      frameNum: "",
      testCarNum: "",
      deptIdStr: store.deptId,
    },
  }).then((res) => {
    console.log(res);
    if (res.code === 200) {
      testCarNumList.value = res.data.records;
    }
  });
};

const testCarNumChange = (value) => {
  console.log(value);
  let res = testCarNumList.value.find((item) => item.id === value);
  console.log(res);
  form.value.testCarNum = res.testCarNum;
};

const fileUrl = ref("");
// 获取模板
const getTemplateFileUrlData = () => {
  getTemplateFileUrl().then((res) => {
    console.log(res);
    if (res.code === 200) {
      fileUrl.value = res.data;
    }
  });
};

const add = () => {
  title.value = "上传报告";
  modalRef.value.showModal();
  getCarsData();
};

const confirm = () => { };

const afterVisibleChange = (bool) => {
  console.log("open", bool);
};

const open = ref(false);
const detailForm = ref({});
const detail = (record) => {
  console.log(record);
  title.value = "报告详情";
  open.value = true;

  detailData({ id: record.id }).then((res) => {
    console.log(res);
    if (res.code === 200) {
      detailForm.value = res.data;
    }
  });
};

const closeOpen = () => {
  open.value = false;
};

// 取消
const cancel = () => {
  console.log("取消");
  open.value = false;
  formRef.value.resetFields();
};

function saveEvent(a) {
  console.log("保存");
  console.log(form.value);
  insertOne(form.value)
    .then((res) => {
      if (res.code === 200) {
        message.success("上传报告成功");
        getData();
        resetForm();
        uploadRef.value.reset();
      }
    })
    .catch((err) => {
      message.error(err.message);
      resetForm();
    });
}

function cancelEvent() {
  console.log("取消");
  console.log(uploadRef.value);
  resetForm();
  uploadRef.value ? uploadRef.value.reset() : null;
}
onMounted(async () => {
  getData();
  getTemplateFileUrlData();
  console.log(route.query.id);
  if(route.query.id){
    detail({id:route.query.id})
  }

});
</script>
<style lang="less" scoped>
.review {
  padding: 13px 20px 20px 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

.modal_item {
  padding: 0 26px 106px 23px;
  background: #f6f8fa;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .file_text {
    padding-top: 19px;
    border-bottom: 1px solid #d4e0f0;

    .fil_it {
      display: flex;
      align-items: center;
      padding-left: 49px;
      padding-bottom: 19px;

      .file_tit {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #6c7683;
      }

      .file_ic {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1d2129;
      }
    }

    .file_icon {
      color: rgba(24, 111, 242, 1);
    }
  }
}

.mr10 {
  margin-left: 10px;
}

a {
  color: #1e8ef2;
}

.radio_class {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgba(29, 33, 41, 1);
}

.area_class {
  // display: flex;
}

.area_width {
  // width: 420px;
  // margin-left: 26px;
  margin-top: 22px;
}

.mt22 {
  margin-top: 22px;
}

.mt32 {
  margin-top: 32px;
}

.mb85 {
  margin-bottom: 85px;
}

.mb26 {
  margin-bottom: 26px;
}

.ml26 {
  margin-left: 26px;
}

.pl30 {
  padding-left: 30px;
}

.pl43 {
  padding-left: 43px;
}

.pl15 {
  padding-left: 15px;
}

.pl55 {
  padding-left: 55px;
}

.pl89 {
  padding-left: 89px;
}

.pl91 {
  padding-left: 91px;
}

.detail {
  padding: 30px 80px 30px 80px;

  .cars {
    border: 1px solid #e1e7ef;
    margin-bottom: 24px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;

    .item {
      display: flex;
      align-items: center;
    }

    .tit {
      background: #f6f8fa;
      padding: 11px 33px;
      font-weight: 600;
      color: #1d2129;
      width: 125px;
      padding: 11px;
      text-align: right;

      margin-right: 25px;
    }

    .cont {
      padding: 15px 28px;
    }
  }

  .filelist {
    border: 1px solid #e1e7ef;
    padding: 20px 0;
    text-align: center;

    .item {
      color: #636d7b;
      font-size: 14px;

      .anticon {
        color: #186ff2;
        margin-right: 13px;
      }
    }

    .btns {
      margin-top: 19px;
    }
  }

  .file_text {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #1d2129;
  }

  .into {
    font-size: 14px;
    color: #636d7b;
    margin: 16px 0;
  }

  .update_btn {
    cursor: pointer;
    display: inline-block;
    padding: 2px 0;
    width: 100px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #636d7b;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #636d7b;
    text-align: center;
  }
}

.newDetail {
  padding: 26px 0 30px 129px;

  .cars {
    margin-bottom: 46px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;

    .item {
      display: flex;
      align-items: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
      margin-bottom: 24px;
    }

    .tit {
      width: 125px;
      text-align: right;
      margin-right: 16px;
    }

    .cont {
      padding: 15px 28px;
    }
  }

  .filelist {
    border: 1px solid #e1e7ef;
    padding: 20px 0;
    text-align: center;
    width: 513px;
    height: 120px;
    background: #f6f8fa;
    margin-left: 41px;

    .item {
      color: #636d7b;
      font-size: 14px;

      .anticon {
        color: #186ff2;
        margin-right: 13px;
      }
    }

    .btns {
      margin-top: 19px;
    }
  }
}

.add {
  .cars {
    border: none;

    .tit {
      background-color: transparent;
      width: 125px;
      padding: 11px 0;
      text-align: right;
    }

    .cont {
      padding: 0;
      width: 100%;
    }
  }

  .filelist {
    text-align: center;
    background: #f6f8fa;
  }
}

.update_btn {
  cursor: pointer;
  padding: 3px 0;
  width: 100px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #636d7b;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #636d7b;
  text-align: center;
  margin: 20px auto 0;
}

.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.upload_a {
  display: inline-block;
  width: 60px;
  height: 32px;
  background: #1e8ef2;
  color: #fff;
  box-shadow: 0 2px 0 rgba(8, 96, 137, 0.17);
  padding: 4px 15px;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  line-height: 22px;
}

/deep/.ant-tabs .ant-tabs-tab {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  margin: 0 0 0 70px;
  color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
}

/deep/.ant-tabs-nav {
  margin-bottom: 24px;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
  height: 3px;
  // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
  width: 130px;
}
</style>
